module.exports = __webpack_public_path__ + "img/arrow-1.8b8f727a.svg";